<template>
  <div>
    <v-form v-model="isFormValid" ref="form">
      <v-text-field
        :value="entity.name || ''"
        :rules="[ValidationRules.requiredString]"
        label="Name"
        @change="$emit('update', { name: $event })"
        v-bind="globalFieldAttrs"
      />
      <!-- Start Time -->
      <AdminFieldWrapper label="Start Time">
        <AdminInputDatetime
          :timestamp="entity.start_time_in_local_tz"
          label="Start Time"
          @update="updateTimeInUTC('start_time', $event)"
          v-bind="globalFieldAttrs"
        />
      </AdminFieldWrapper>

      <!-- End Time -->
      <AdminFieldWrapper label="End Time">
        <AdminInputDatetime
          :timestamp="entity.end_time_in_local_tz"
          label="End Time"
          @update="updateTimeInUTC('end_time', $event)"
          v-bind="globalFieldAttrs"
        />
      </AdminFieldWrapper>
      <!-- Delivery Slots -->
      <AdminFieldWrapper label="Delivery Slots">
        <AdminFieldMultiselect
          :value="entity.delivery_slots"
          label="Delivery Slots"
          :items="getDeliverySlots"
          @change="$emit('update', { delivery_slots: $event })"
          v-bind="globalFieldAttrs"
        />
      </AdminFieldWrapper>
      <!-- Pickup Slots -->
      <AdminFieldWrapper label="Pickup Slots">
        <AdminFieldMultiselect
          :value="entity.pickup_slots"
          label="Pickup Slots"
          :items="getPickupSlots"
          @change="$emit('update', { pickup_slots: $event })"
          v-bind="globalFieldAttrs"
        />
      </AdminFieldWrapper>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { localToUtc } from '@/utils/utcConverter'

import AvailabilityModel from '@/models/AvailabilityModel'
import ValidationRules from '@/constants/ValidationRules'

import AdminInputDatetime from '@/components/AdminInputDatetime'
import AdminFieldMultiselect from '@/components/AdminFieldMultiselect'
import AdminFieldWrapper from '@/components/AdminFieldWrapper'
export default {
  name: 'AdminEditAvailabilityForm',
  components: {
    AdminFieldWrapper,
    AdminInputDatetime,
    AdminFieldMultiselect,
  },
  props: {
    entity: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data() {
    return {
      isFormValid: false,
      ValidationRules,
      AvailabilityModel,
    }
  },
  methods: {
    async updateTimeInUTC(key, timestamp) {
      let timeInUTC = await localToUtc(timestamp)
      this.$emit('update', { [key]: timeInUTC })
    }, // updateTimeInUTC
  },
  mounted() {
    this.$refs.form.validate()
  },
  computed: {
    ...mapGetters('shop', ['getDeliverySlots', 'getPickupSlots']),
    globalFieldAttrs() {
      const defaults = { outlined: true, dense: true }
      return { ...defaults }
    },
  },
  watch: {
    isFormValid(validity) {
      this.$emit('form:valid', validity)
    },
  },
}
</script>
